import React from "react";
import { useState, useEffect } from "react";
import { Form, Button, Col, Row, Container, Modal } from "react-bootstrap";
import {
  utilCreateProductoInventario,
  saveImageToFirebaseStorage,
  utilUpdateProductoInventario,
  utilDeleteProductoInventario
} from "../../../util/UtilsFirebase";

import Switch from 'react-switch';

import { useAuthContext } from '../../../hooks/useAuthContext'
import "./ProductoModal.css";


const ProductoModal = ({ inventario, showProducto,mod, itemProducto, handleCloseProducto }) => {

  const { register } = useAuthContext();
  const [producto, setProducto] = useState({ Nombre: "", 'Tipo de unidad': "", Cantidad: 0});
  const [isDelete, setIsDelete] = useState(false);

  useEffect(() => {

    if(mod){

      setProducto(itemProducto);

      if(mod === "DLT"){
        setIsDelete(true);
      }
      else {
        setIsDelete(false);        
      }

    }



  }, [itemProducto]);

  const handleChange = (e) => {

        setProducto({
              ...producto,
              [e.target.name]: e.target.value,
            });

  };

  const handleCloseLocal = async () => {
    //setProducto(null);
    handleCloseProducto();
  };

  const saveProducto = async () => {

    if(mod === "ADD") {

      const ProductoReg = await utilCreateProductoInventario( producto,inventario.id);

      console.log(ProductoReg)
      handleCloseProducto();
    }

    if(mod === "UPD") {
      
      utilUpdateProductoInventario(inventario.id, producto);
      handleCloseProducto();
    }

    if(mod === "DLT"){      
      utilDeleteProductoInventario(inventario.id, producto);
      handleCloseProducto();

      // Esta linea unicamente la utilizo para pruebas e identificar el id del menu relacionado al platillo que se esta eliminado.
      //alert("Menu ID: " + menu.id)
      //alert("Producto ID: " + Producto.id);
    }


  };

  return (
    <Modal show={showProducto} onHide={handleCloseProducto} size="md">
      <Modal.Header closeButton>
        <Modal.Title>{mod && mod == "ADD" ? "AGREGAR": ""} {mod && mod == "UPD" ? "MODIFICAR": ""} {mod && mod == "DLT" ? "ELIMINAR": ""} Producto</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col >

            <Form >
              {mod && mod == "DLT" ? (
                <Row>
                  <Col md={12}>
                    <label htmlFor="">¿Esta seguro de borrar el producto?</label>
                  </Col>
                </Row>
              ): ("")}

              <Row>
                <Col md={12}>
                    <Form.Group controlId="razonSocial">
                    <Form.Label>Nombre del producto:</Form.Label>
                    <Form.Control disabled={isDelete} onChange={handleChange} value={producto?.Nombre} name='Nombre'  required type="text"  />
                </Form.Group>
                </Col>
                <Col md={6}>
                <Form.Group controlId="razonSocial">
                    <Form.Label>Tipo de unidad:</Form.Label>
                    <Form.Control disabled={isDelete} onChange={handleChange} value={producto['Tipo de unidad']} name='Tipo de unidad'  required type="text"  />
                </Form.Group>
                </Col>
                <Col md={6}>
                <Form.Group controlId="razonSocial">
                    <Form.Label>Cantidad:</Form.Label>
                    <Form.Control disabled={isDelete} onChange={handleChange} value={producto?.Cantidad} name='Cantidad'  required type="text"  />
                </Form.Group>
                </Col>
              </Row>

            </Form>



            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseLocal}>
          CANCELAR
        </Button>
        <Button variant={mod && mod == "DLT" ? 'danger':'primary'} onClick={saveProducto}>
        {mod && mod == "DLT" ? 'ELIMINAR':'GUARDAR'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductoModal;
